import React from 'react';
import PropTypes from 'prop-types';

function BaseText({ title, className, textColor, textAlign, fontWeight, lineHeight, fontSize }) {
  return (
    <p
      style={{ fontSize: fontSize, lineHeight: lineHeight }}
      className={`${fontWeight} ${textColor} ${textAlign} ${className && className}`}
    >
      {title}
    </p>
  );
}

export default BaseText;

BaseText.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  textColor: PropTypes.string,
  textAlign: PropTypes.string,
  fontWeight: PropTypes.string,
  lineHeight: PropTypes.string
};

BaseText.defaultProps = {
  textColor: 'text-gray-700',
  textAlign: 'text-left',
  fontWeight: 'text-regular',
  fontSize: '18px'
};
